import http from "./http";
import { toast } from "react-toastify";

const ENDPOINT = "admin_call_package";

/* =========================
   LIST (SEARCH + PAGINATION)
========================= */
export const getPackageList = async ({
  page = 1,
  limit = 10,
  search = "",
} = {}) => {
  try {
    const res = await http.get(
      `${ENDPOINT}?action=list&page=${page}&limit=${limit}&search=${search}`
    );

    return {
      data: res.data?.data || [],
      total: res.data?.total || 0,
    };
  } catch {
    toast.error("Failed to load packages");
    return { data: [], total: 0 };
  }
};

/* =========================
   GET BY ID
========================= */
export const getPackageById = async (id) => {
  try {
    const res = await http.get(`${ENDPOINT}?action=get&id=${id}`);
    return res.data?.data || null;
  } catch {
    toast.error("Failed to load package");
    return null;
  }
};

/* =========================
   ADD
========================= */
export const addPackage = async (payload) => {
  try {
    const res = await http.post(`${ENDPOINT}?action=add`, payload);
    if (res.data?.status === "success") {
      toast.success("Package added successfully");
      return true;
    }
    toast.error(res.data?.message || "Add failed");
    return false;
  } catch {
    toast.error("Add API error");
    return false;
  }
};

/* =========================
   UPDATE
========================= */
export const updatePackage = async (payload) => {
  try {
    const res = await http.post(`${ENDPOINT}?action=edit`, payload);
    if (res.data?.status === "success") {
      toast.success("Package updated successfully");
      return true;
    }
    toast.error(res.data?.message || "Update failed");
    return false;
  } catch {
    toast.error("Update API error");
    return false;
  }
};

/* =========================
   STATUS
========================= */
export const changePackageStatus = async (id, status) => {
  try {
    const res = await http.post(`${ENDPOINT}?action=status`, { id, status });
    if (res.data?.status === "success") {
      toast.success("Status updated");
      return true;
    }
    toast.error("Status update failed");
    return false;
  } catch {
    toast.error("Status API error");
    return false;
  }
};

/* =========================
   DELETE
========================= */
export const deletePackage = async (id) => {
  try {
    const res = await http.post(`${ENDPOINT}?action=delete`, { id });
    if (res.data?.status === "success") {
      toast.success("Package deleted");
      return true;
    }
    toast.error("Delete failed");
    return false;
  } catch {
    toast.error("Delete API error");
    return false;
  }
};
